import { CircularProgress } from "@mui/material";
import React from "react";

const ComponentLoader = () => {
  return (
    <div className="flex justify-center items-center h-full gap-2">
      <CircularProgress size={20} />
      <span className="text-[20px] text-gray-600">Loading...</span>
    </div>
  );
};

export default ComponentLoader;
